import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {SPHERE} from '../../models/patient-sphere';
import {PatientGoalNumberTypeEnum} from '../../enums/patient-goal';
import {RecordTypeEnum} from '../../enums/record';
import {IPatient} from '../../models/patient';

@Component({
  selector: 'app-complete-sphere',
  templateUrl: './complete-sphere.component.html',
  styleUrls: ['./complete-sphere.component.scss']
})
export class CompleteSphereComponent implements OnInit {

  @Input() patientRelevantData: SPHERE.ISphere;
  @Input() patient: IPatient;

  @Output() redirectTo: EventEmitter<RecordTypeEnum> = new EventEmitter<RecordTypeEnum>();

  patientGoalNumberType = PatientGoalNumberTypeEnum;

  constructor() {}

  ngOnInit(): void {
  }

  async onRedirectTo(record: RecordTypeEnum): Promise<void> {
    this.redirectTo.emit(record);
  }
}
